import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "repeat",
  "use": "repeat-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"repeat\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path fill=\"#8c263e\" fill-rule=\"nonzero\" d=\"M2 14.5a.5.5 0 1 1-1 0v-4a.5.5 0 0 1 .5-.5h4a.5.5 0 1 1 0 1H2.802a6 6 0 1 0 .959-7.247.5.5 0 0 1-.706-.707A7 7 0 1 1 2 11.608V14.5z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/units/Icon/icons/repeat.svg
// module id = 514
// module chunks = 1